export const getSlotStyles = (length: number, index: number) => {
  const centerAngle = 360 / length;
  const skewY = -(90 - centerAngle);
  const actAngle = centerAngle * (index + 1);

  switch (length) {
    case 2:
      return {
        top: '0%',
        height: '100%',
        transformOrigin:'center left',
        transform: `rotate(${actAngle}deg)`,
      }
    case 3:
      return {
        top: '-10%',
        height: '60%',
        transformOrigin:'0% 100%',
        transform: `rotate(${actAngle}deg) skewY(${skewY}deg)`,
      }
    default:
      return {
        top: '0%',
        height: '50%',
        transformOrigin:'0% 100%',
        transform: `rotate(${actAngle}deg) skewY(${skewY}deg)`,
      }
  }
}

export const getTextStyles = (length: number) => {
  const centerAngle = 360 / length;
  const rotationAngle = (centerAngle / 2);
  const skewY = 90 - centerAngle;

  switch (length) {
    case 2:
      return {
        height: '100%',
        transform: `rotate(${rotationAngle}deg)`,
        fontSize: { base: 'sm', md: 'sm', lg: 'lg' }
      }
    case 3:
      return {
        height: '165%',
        top: '15%',
        transform: `skewY(${skewY}deg) rotate(${rotationAngle}deg)`,
        fontSize: { base: 'sm', md: 'sm', lg: 'lg' }
      }
    default:
      return {
        height: '200%',
        transform: `skewY(${skewY}deg) rotate(${rotationAngle}deg)`,
        fontSize: { base: 'xs', md: 'sm', lg: 'lg' }
      }
  }
}